<div class="login-page">

  <!-- Painel esquerdo - Branding -->
  <div class="login-branding">
    <div class="branding-content">
      <img src="assets/icon-clinixcore-light.svg" alt="ClinixCore" class="brand-icon-hero">
      <h1 class="brand-title">ClinixCore</h1>
      <p class="brand-subtitle">O núcleo da sua prática clínica</p>
      <p class="brand-description">Sistema completo de gestão clínica e financeira para profissionais de saúde</p>
      <div class="brand-features">
        <div class="feature-item"><i class="bi bi-check-circle-fill"></i> Agenda inteligente</div>
        <div class="feature-item"><i class="bi bi-check-circle-fill"></i> Prontuário eletrônico</div>
        <div class="feature-item"><i class="bi bi-check-circle-fill"></i> Gestão financeira</div>
        <div class="feature-item"><i class="bi bi-check-circle-fill"></i> 30 dias grátis</div>
      </div>
    </div>
  </div>

  <!-- Painel direito - Formulário -->
  <div class="login-form-panel">
    <div class="login-card">

      <!-- Logo Mobile -->
      <div class="text-center mb-4 d-md-none">
        <img src="assets/logo-clinixcore.svg" alt="ClinixCore" style="height: 45px;">
      </div>

      <!-- Tabs -->
      <div class="auth-tabs mb-4">
        <button class="auth-tab" [class.active]="isLoginMode"
                (click)="isLoginMode = true; errorMessage = ''">
          Entrar
        </button>
        <button class="auth-tab" [class.active]="!isLoginMode"
                (click)="isLoginMode = false; errorMessage = ''">
          Criar Conta
        </button>
      </div>

      <!-- Mensagem de erro -->
      <div class="alert alert-danger d-flex align-items-center gap-2 mb-3" *ngIf="errorMessage">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- =================== SEÇÃO GOOGLE =================== -->
      <div class="google-section mb-3">

        <!-- Botão Google OFICIAL renderizado pelo SDK -->
        <div id="google-btn-container"
             [class.d-none]="!googleReady || googleLoading"
             style="min-height: 44px; display:flex; justify-content:center;">
        </div>

        <!-- Botão CUSTOMIZADO: aparece enquanto SDK não carregou OU como fallback 
        <button class="btn-google-custom w-100"
                (click)="onGoogleClick()"
                [disabled]="googleLoading"
                [class.d-none]="googleReady && !googleLoading">
          <span *ngIf="!googleLoading">
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {{ isLoginMode ? 'Continuar com Google' : 'Cadastrar com Google' }}
          </span>
          <span *ngIf="googleLoading" class="d-flex align-items-center justify-content-center gap-2">
            <span class="spinner-border spinner-border-sm"></span>
            Autenticando com Google...
          </span>
        </button>-->

      </div>

      <!-- Divisor -->
      <div class="divider mb-3">
        <span>{{ isLoginMode ? 'ou entre com email' : 'ou crie com email' }}</span>
      </div>

      <!-- =================== LOGIN =================== -->
      <div *ngIf="isLoginMode">
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">

          <div class="mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email"
                   placeholder="seu@email.com"
                   [class.is-invalid]="f['email'].invalid && f['email'].touched">
            <div class="invalid-feedback">
              <span *ngIf="f['email'].hasError('required')">Email obrigatório</span>
              <span *ngIf="f['email'].hasError('email')">Email inválido</span>
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label">Senha</label>
            <div class="input-password">
              <input [type]="showPassword ? 'text' : 'password'"
                     class="form-control" formControlName="password"
                     placeholder="••••••••"
                     [class.is-invalid]="f['password'].invalid && f['password'].touched">
              <button type="button" class="btn-eye" (click)="showPassword = !showPassword">
                <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
              </button>
            </div>
            <div class="invalid-feedback d-block"
                 *ngIf="f['password'].invalid && f['password'].touched">
              Senha obrigatória (mínimo 6 caracteres)
            </div>
          </div>

          <div class="mb-3 text-end">
            <a [routerLink]="['/forgot-password']" class="text-muted small text-decoration-none">
              <i class="bi bi-key me-1"></i>
              Esqueceu sua senha?
            </a>
          </div>

          <button type="submit" class="btn btn-primary w-100" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ loading ? 'Entrando...' : 'Entrar' }}
          </button>
        </form>

        <p class="text-center mt-4 mb-0 text-muted">
          Não tem conta?
          <a href="javascript:void(0)" (click)="toggleMode()" class="link-primary fw-semibold">
            Crie gratuitamente
          </a>
        </p>
      </div>

      <!-- =================== REGISTRO =================== -->
      <div *ngIf="!isLoginMode">

        <!-- Banner de Convite -->
        <div class="alert alert-info d-flex align-items-start gap-2 mb-3" *ngIf="inviteInfo">
          <i class="bi bi-envelope-check fs-5"></i>
          <div>
            <strong>Convite de {{ inviteInfo.professionalName }}</strong>
            <p class="mb-0 mt-1 small">
              Você foi convidado para colaborar como <strong>{{ inviteInfo.role }}</strong>.
              Complete o cadastro abaixo para aceitar o convite.
            </p>
          </div>
        </div>

        <!-- Loading de validação -->
        <div class="alert alert-secondary d-flex align-items-center gap-2 mb-3" *ngIf="validatingInvite">
          <span class="spinner-border spinner-border-sm"></span>
          Validando convite...
        </div>

        <form [formGroup]="registerForm" (ngSubmit)="onRegister()">

          <div class="mb-3">
            <label class="form-label">Nome Completo</label>
            <input type="text" class="form-control" formControlName="name"
                   placeholder="Seu nome completo"
                   [class.is-invalid]="r['name'].invalid && r['name'].touched">
            <div class="invalid-feedback">Nome obrigatório</div>
          </div>

          <div class="mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email"
                   placeholder="seu@email.com"
                   [class.is-invalid]="r['email'].invalid && r['email'].touched">
            <div class="invalid-feedback">
              <span *ngIf="r['email'].hasError('required')">Email obrigatório</span>
              <span *ngIf="r['email'].hasError('email')">Email inválido</span>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Telefone</label>
            <input type="tel" class="form-control" formControlName="phone"
                   (input)="onPhoneInput($event)"
                   placeholder="(11) 98765-4321" maxlength="15"
                   [class.is-invalid]="r['phone'].invalid && r['phone'].touched">
            <div class="invalid-feedback">Telefone obrigatório</div>
          </div>

          <div class="mb-3">
            <label class="form-label">Senha</label>
            <div class="input-password">
              <input [type]="showPassword ? 'text' : 'password'"
                     class="form-control" formControlName="password"
                     placeholder="Mínimo 6 caracteres"
                     [class.is-invalid]="r['password'].invalid && r['password'].touched">
              <button type="button" class="btn-eye" (click)="showPassword = !showPassword">
                <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
              </button>
            </div>
            <div class="invalid-feedback d-block"
                 *ngIf="r['password'].invalid && r['password'].touched">
              Senha deve ter no mínimo 6 caracteres
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label">Confirmar Senha</label>
            <div class="input-password">
              <input [type]="showConfirmPassword ? 'text' : 'password'"
                     class="form-control" formControlName="confirmPassword"
                     placeholder="Repita a senha"
                     [class.is-invalid]="registerForm.hasError('passwordMismatch') && r['confirmPassword'].touched">
              <button type="button" class="btn-eye" (click)="showConfirmPassword = !showConfirmPassword">
                <i class="bi" [class.bi-eye]="!showConfirmPassword" [class.bi-eye-slash]="showConfirmPassword"></i>
              </button>
            </div>
            <div class="text-danger small mt-1"
                 *ngIf="registerForm.hasError('passwordMismatch') && r['confirmPassword'].touched">
              As senhas não coincidem
            </div>
          </div>

          <div class="trial-badge mb-3">
            🎉 <strong>30 dias grátis</strong> · Após o trial: R$ 39,90/mês por profissional
          </div>

          <button type="submit" class="btn btn-primary w-100" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ loading ? 'Criando conta...' : 'Criar Conta Gratuita' }}
          </button>
        </form>

        <p class="text-center mt-4 mb-0 text-muted">
          Já tem conta?
          <a href="javascript:void(0)" (click)="toggleMode()" class="link-primary fw-semibold">
            Fazer login
          </a>
        </p>
      </div>

    </div>
  </div>
</div>
